export default {
  building: {
    name: '',
    group: { id: null },
    location: { id: null },
    squareFeet: 0,
    studentsEnrolled: 0,
    fullTimeEmployees: 0
  },
  buildings: []
}



// WEBPACK FOOTER //
// ./src/store/modules/building/state.js